import { useCallback } from 'react'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import {
  getClinicalMixTreatmentProfileReport,
  type ClinicalMixTreatmentProfileReportResult,
} from '@services/api/reports/providerPerformance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type ClinicalMixTreatmentProfileData =
  ClinicalMixTreatmentProfileReportResult

export type UseClinicalMixTreatmentProfileResult = {
  loading: boolean
  error: string | null
  data: ClinicalMixTreatmentProfileData | null
  bucketLabel: string
}

export function useClinicalMixTreatmentProfile(
  toolbarSelection: Record<string, string>,
): UseClinicalMixTreatmentProfileResult {
  const getBucketFromData = useCallback(
    (data: ClinicalMixTreatmentProfileReportResult): ReportBucketType =>
      data.totalProcedures.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getClinicalMixTreatmentProfileReport,
    getBucketFromData,
    errorMessage: 'Failed to load clinical mix treatment profile data',
  })
}
